<template>
  <div class="community_container">
    <div class="list_wrapper">
      <div class="list_item" v-for="(item, index) in recordData" :key="index">
        <!--   我的收藏社区删除占位图     -->
        <div v-if="item?.isExits === 0 && pageType" class="default">
          <div class="default_box">
            <p class="img_tag">{{ $t('pc_course_invalid') }}</p>
          </div>
          <div class="default_text_box">
            <p class="default_text">{{ $t('pc_community_is_deleted') }}</p>
            <div class="default_ellipsis">
              <Popover @cancel="cancelCollect(item)" />
            </div>
          </div>
        </div>
        <template v-else>
          <div class="item_title"
            @click="handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status)">
            <img :src="item.avatarFileUrl ? item.avatarFileUrl : require('@/assets/images/wx_share_default.jpg')"
              class="title_img" alt="" />
            <span class="title_author">{{ item?.createByName }}</span>
            <span class="title_label">{{ item?.postName }}</span>
          </div>
          <div class="item_subtitle" :class="item.type === 2 ? 'subTitle' : ''"
            @click="handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status)">{{
              item?.title }}</div>
          <div v-if="item.type !== 2">
            <p class="item_content">{{ item?.articleText }}</p>
            <div class="img-wrapper" :class="item.attachments?.length === 1
                ? 'item_img_one'
                : item.attachments?.length === 2
                  ? 'item_img_two'
                  : 'item_img'
              " v-if="item?.attachments"
              @click.stop="item?.attachments.length === 1 && isVideo(item?.attachments[0]?.type) ? null : handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status)">
              <div v-if="item?.attachments.length === 1 && isVideo(item?.attachments[0]?.type)" class="img_item">
                <div v-if="+item?.attachments[0]?.status === 3">
                  <Player :id="item?.attachments[0].id" :url="item?.attachments[0].previewUrl"
                    :coverUrl="item?.attachments[0].coverUrl" :boardId="item.boardId" :rollVideoId="item.id"></Player>
                </div>
                <div v-else class="default-video" @click="handleDefaultVideo">
                  <div class="Lottie_color">
                    <LottieFlow />
                  </div>
                  <p class="announcing_text">{{ $t('under_release_h5') }}</p>
                  <p class="announcing_text">{{ $t('video_refresh_h5') }}</p>
                </div>
              </div>
              <template v-else>
                <div class="img-box" v-for="(i, k) in item?.attachments.slice(0, 3)" :key="k">
                  <img v-if="i?.previewUrl" :src="i?.previewUrl"
                    :class="item?.attachments.length === 1 ? 'cale-item' : 'img_item'"
                    :style="item?.attachments.length === 1 ? getSize(i.size) : {}"
                    @click.stop="showPreview(item.attachments, k)" alt="" />
                  <div v-else class="default-img"></div>
                </div>
                <div v-if="item.attachments?.length > 3" class="img-num">
                  {{ formatLang($t('pc_community_total_piece'), [item?.attachments.length + '']) }}
                </div>
              </template>
            </div>
          </div>
          <div class="item-article" v-else @click="handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status)">
            <p class="item_content">{{item?.articleText}}</p>
            <div class="item_img_article" v-if="item?.attachments && item?.attachments.length > 0">
              <img v-for="(i, k) in item.attachments" :key="k" :src="i?.previewUrl" class="img_item" alt="" />
            </div>
          </div>

          <div class="item_count" @click="handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status)">
            <span class="count_time">{{ formatTime(item?.createTime) }}</span>
            <div class="count_warpper" v-if="flag">
              <div class="count_item">
                <i class="iconfont icon-icon_shequzhongxin_liulanliang" />
                <span class="count_item_text">{{ toW(item?.viewCount) }}</span>
              </div>
              <div class="count_item">
                <i class="iconfont icon-icon_shouye_pinglun" />
                <span class="count_item_text">{{ toW(item.commentCount) }}</span>
              </div>
              <div class="count_item" @click.stop="toggleIsLike(item)">
                <i class="iconfont icon-icon_shouye_dianzan" v-show="!item.isLike" />
                <i class="iconfont icon-icon_shouye_hangyedongtai_dianzan_O active" v-show="item.isLike"></i>
                <span class="count_item_text">{{ toW(Number(item?.likeCount)) }}</span>
              </div>
            </div>
            <div v-else class="cancel_pop">
              <Popover @cancel="cancelCollect(item)" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Record } from '@/api/Models/CommunityBoardContentList'
import { Attachment } from '@/api/Models/Attachment'
import { isVideo, isFile } from '@/utils/file'
import Player from './Player.vue'
import { computed, getCurrentInstance, ComponentInternalInstance, ref } from 'vue'
import Popover from '@/components/Popover.vue'
import { calcImageScaleWithSize, screenWidth, toW } from '@/utils'
import { useRouter } from 'vue-router'
import APIRequest from '@/api'
import { formatLang, formatTime } from '@/utils/format'
import { useI18n } from 'vue-i18n'
import { useComponentStore } from '@/stores/components'
import { storeToRefs } from 'pinia'
import { showToast } from 'vant'
import LottieFlow from '../../shortVideo/components/LottieFlow.vue'

const props = defineProps<{
  articleData: Record[]
  active?: number | undefined
  pageType?: number //  0 社区  1 收藏
  page?: number
}>()
const flag = ref<boolean>(props.pageType !== 1)
const { t } = useI18n()
const getSize = (size: string) => {
  const divWidth = screenWidth - 32 - 24
  const divHeight = divWidth * 0.75
  let width = divWidth + 'px'
  let height = divHeight + 'px'
  if (size) {
    const originSize = JSON.parse(size)
    width = originSize.imageWith
    height = originSize.imageHigh
    if (Number(originSize.imageWith) > Number(originSize.imageHigh)) {
      width = divWidth + 'px'
      height = originSize.imageHigh * (divWidth / originSize.imageWith) + 'px'
    } else {
      height = divHeight + 'px'
      width = originSize.imageWith * (divHeight / originSize.imageHigh) + 'px'
    }
  }
  return {
    width,
    height
  }
}
const recordData = computed(() => {
  try {
    const filteredData = props.articleData?.map((item) => {
      return {
        ...item,
        ...item?.communityContent,
        attachments: item?.communityContent
          ? item?.communityContent.attachments
            ?.filter((el) => !isFile(el.type))
            ?.map((e) => {
              let imgSize = {
                imageWith: '340',
                imageHigh: '250'
              }
              if (e.expandInfo) {
                imgSize = JSON.parse(e.expandInfo)
              }
              return {
                previewUrl: isVideo(e.type)
                  ? e.previewUrl
                  : calcImageScaleWithSize(
                    e.previewUrl as string,
                    parseInt(imgSize.imageWith),
                    parseInt(imgSize.imageHigh),
                    1500,
                    1500
                  ),
                type: e.type,
                name: e.name,
                id: e.id,
                coverUrl: e.coverUrl,
                size: e?.expandInfo,
                status: e?.status
              }
            }) || []
          : item?.attachments
            ?.filter((el) => !isFile(el.type))
            ?.map((e) => {
              let imgSize = {
                imageWith: '340',
                imageHigh: '250'
              }
              if (e.expandInfo) {
                imgSize = JSON.parse(e.expandInfo)
              }
              return {
                previewUrl: isVideo(e.type)
                  ? e.previewUrl
                  : calcImageScaleWithSize(
                    e.previewUrl as string,
                    parseInt(imgSize.imageWith),
                    parseInt(imgSize.imageHigh),
                    1500,
                    1500
                  ),
                type: e.type,
                name: e.name,
                id: e.id,
                coverUrl: e.coverUrl,
                size: e.expandInfo,
                status: e.status
              }
            }) || []
      }
    })
    return filteredData as unknown as Record[]
  } catch (error) {
    return []
  }
})

const { proxy } = getCurrentInstance() as ComponentInternalInstance

const likeHandle = async (item: Record) => {
  const { code } = await APIRequest.CommentLike.postLikeSend({
    likeModule: 3,
    likeModuleId: item.id,
    loadingShow: '0'
  })
  if (code === 1) {
    item.likeCount = Number(item.likeCount) + 1
    item.isLike = true
    proxy?.$forceUpdate()
  }
}
const dontLikeHandle = async (item: Record) => {
  const { code } = await APIRequest.CommentLike.postLikeCancel({
    likeModule: 3,
    likeModuleId: item.id
  })
  if (code === 1) {
    item.likeCount = Number(item.likeCount) - 1
    item.isLike = false
    proxy?.$forceUpdate()
  }
}
const toggleIsLike = (item: Record) => {
  if (item.isLike) {
    dontLikeHandle(item)
  } else {
    likeHandle(item)
  }
}

const emits = defineEmits(['showPreview', 'cancelCollect'])
const showPreview = (attachments: Attachment[], index: number) => {
  emits('showPreview', { attachments, index })
}

const router = useRouter()
const handleJump = (id: string, type?: string, boardId?: string, status?: number) => {
  const componentsStore = useComponentStore()
  const { includeComponents } = storeToRefs(componentsStore)
  if (!includeComponents.value.includes('communityDetail') && !props.page) {
    componentsStore.setIncludeComponents([...includeComponents.value, 'communityDetail'])
  }
  if (props.page) {
    const filteredArr = includeComponents.value.filter(element => element !== 'communityDetail')
    componentsStore.setIncludeComponents(filteredArr)
  }
  if (type && isVideo(type)) {
    if (status === 3) {
      router.push({
        path: '/rollVideo',
        query: {
          sortType: 0,
          id,
          boardId
        }
      })
    } else {
      showToast(t('video_processing_h5'))
    }
  } else {
    router.push({ path: '/comDetailLevel', query: { id, from: props.page } })
  }
}

const handleDefaultVideo = () => {
  showToast(t('video_processing_h5'))
}

const cancelCollect = (item: { collectModuleId: string; collectModuleType: number }) => {
  emits('cancelCollect', { collectModuleId: item.collectModuleId, collectModuleType: item.collectModuleType })
}

</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');
@imgWidth: calc(((100vw - 32px - 24px - 16px) / 3));
@twoImgWidth: calc(((100vw - 32px - 24px - 8px) / 2));
@oneImgWidth: calc(100vw - 32px - 24px);

.community_container {
  .list_wrapper {
    .list_item {
      overflow: hidden;
      background: #fff;
      padding: 0 12px 12px;
      border-radius: 8px;
      margin-bottom: 12px;
      .border_1px_b;

      &:last-child {
        margin-bottom: 0;
      }

      .item_title {
        padding: 12px 0;
        display: flex;
        align-items: center;

        .title_img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          object-fit: cover;
        }

        .title_author {
          margin-left: 6px;
          font-size: 14px;
          font-weight: 500;
        }

        .title_label {
          margin-left: 6px;
          font-size: 14px;
          color: @textSecondary99;
        }
      }

      .item_subtitle {
        margin-bottom: 12px;
        font-size: 16px;
        font-weight: bold;
        .text_multiple_etc(3);
      }

      .item_content {
        font-size: 14px;
        line-height: 21px;
        .text_multiple_etc(3);
      }

      .img-box {
        // background-color: #f4f5f7;
      }

      .cale-item {
        border-radius: 4px;
      }

      .item_img {
        // margin: 12px 0;
        margin-bottom: 12px;
        display: flex;
        justify-content: space-between;

        .img_item {
          width: @imgWidth;
          height: calc(@imgWidth * 0.75);
          object-fit: cover;
          border-radius: 4px;

          &+.img_item {
            margin-left: 8px;
          }
        }
      }

      .item_img_two {
        // padding: 12px 0;
        margin-bottom: 12px;
        display: flex;
        justify-content: space-between;

        .img_item {
          width: @twoImgWidth;
          height: calc(@twoImgWidth * 0.75);
          object-fit: cover;
          border-radius: 4px;

          &+.img_item {
            margin-left: 8px;
          }
        }
      }

      .item_img_one {
        // padding: 12px 0;
        margin-bottom: 12px;
        display: flex;

        .img_item {
          width: @oneImgWidth;
          max-height: calc(@oneImgWidth * 0.75);
          object-fit: contain;
          object-position: top left;
          border-radius: 4px;
          overflow: hidden;
        }
      }

      .item-article {
        display: flex;
        flex-direction: row;
        margin-bottom: 12px;

        .item_content {
          flex: 1;
        }

        .item_img_article {
          width: 84px;
          height: 63px;
          margin-left: 8px;
          // background-color: #f4f5f7;

          .img_item {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
        }
      }

      .img-wrapper {
        position: relative;

        .img-num {
          width: 62px;
          height: 21px;
          position: absolute;
          bottom: 0;
          right: 0;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 4px 0 4px 0;
          color: #fff;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .item_count {
        font-size: 12px;
        display: flex;
        align-items: center;

        .count_time {
          flex: 1;
          color: @textSecondary99;
        }

        .cancel_pop {
          font-size: 16px;
          width: 40%;
          text-align: right;

          :deep(.van-popover__wrapper) {
            width: 42%;
          }
        }

        .count_warpper {
          display: flex;

          .count_item {
            margin-left: 18px;
            display: flex;
            align-items: center;

            .iconfont {
              color: @textSecondary99;

              &.active {
                color: #f39b00;
              }
            }

            .icon-icon_shouye_pinglun,
            .icon-icon_shouye_dianzan {
              font-size: 20px;
            }

            .count_item_text {
              margin-left: 5px;
              color: @textNormal;
            }
          }
        }
      }

      .subTitle {
        font-size: 16px;
        font-weight: 500;
      }
    }

    .default-img {
      width: @oneImgWidth;
      height: calc(@oneImgWidth * 0.75);
      border-radius: 4px;
      background: #f4f5f7;
    }

    .default {
      margin-top: 16px;
      display: flex;

      .default_box {
        width: 120px;
        height: 68px;
        background: #e1e1e1;
        border-radius: 4px;
        position: relative;

        .img_tag {
          position: absolute;
          top: 8px;
          left: 8px;
          height: 20px;
          color: #ffffff;
          padding: 0 4px;
          font-size: 13px;
          border-radius: 3px;
          background-color: rgba(0, 0, 0, 0.5);
        }
      }

      .default_text_box {
        flex: 1;
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .default_text {
        font-size: 14px;
        color: #b7b7b7;
      }

      .default_ellipsis {
        text-align: right;

        :deep(.van-popover__wrapper) {
          width: 28%;
        }
      }
    }

    .default-video {
      width: @oneImgWidth;
      height: calc(@oneImgWidth * 0.75);
      border-radius: 4px;
      background: #f4f5f7;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .announcing_text {
      color: #999999;
      font-size: 13px;
      padding: 0 10px;
      text-align: center;
    }

    .Lottie_color {
      opacity: 0.1;
    }
  }
}</style>
